import { Atom } from 'AppReact';
import styled, { css } from "styled-components";

const template = styled.div`
  ${({ theme, displayState }) => css`
    padding: 6px 16px;
    line-height: 17px;
    display: flex;
    align-items: center;
    justify-content: ${displayState?.centeredLabel && 'center'};
    position: relative;
    color: white;

    &:hover {
      color: ${displayState?.disabled ? '' : theme?.colour?.primary ?? '#1DBD6B'};
    }

    @media only screen and (min-width: 768px) {
      padding: ${displayState.big ? '8px 16px' : '4px 16px'};
    }
  `}
`;


export default Atom({ type: 'button', dataType: 'string', template })